import Shapes from '../../utils/shapes';

export default {
    props: ['params', 'zoom'],
    created() {
        this.effectId = ('' + Math.random()).slice(2);
    },
    render() {
        const gradient = this.params.gradient;
        const shapeDefs = Shapes[this.params.shape]({
            ...this.params,
            color: gradient ? `url(#gradient${this.effectId})` : this.params.color,
            effectId: this.effectId,
            zoom: this.zoom
        });
        const parseShape = ({ tag, attrs, children }) => this.$createElement(
            tag,
            { attrs },
            [].concat(children || []).map(parseShape)
        );
        const aspectRatio = this.params.width / this.params.height;
        const createRadialGradient = () => {
            const scaleX = aspectRatio > 1 ? 1 / aspectRatio : 1;
            const scaleY = aspectRatio > 1 ? 1 : aspectRatio;
            return this.$createElement('radialGradient', {
                attrs: {
                    id: 'gradient' + this.effectId,
                    r: .5 * Math.sqrt(1 + Math.pow(aspectRatio > 1 ? aspectRatio : 1 / aspectRatio, 2)),
                    gradientTransform: `translate(${.5 - scaleX / 2} ${.5 - scaleY / 2}) scale(${scaleX} ${scaleY})`
                }
            }, gradient.stops.map(stop =>
                this.$createElement('stop', {
                    attrs: { offset: stop.offset + '%', 'stop-color': stop.color }
                })
            ));
        };
        const viewBox = this.params.strokeNumeric && !this.params.shapeLinear
            ? `${-this.params.width * this.zoom / 2} ${-this.params.height * this.zoom / 2} ${this.params.width * this.zoom} ${this.params.height * this.zoom}`
            : `${-aspectRatio} -1 ${2 * aspectRatio} 2`;
        return this.$createElement(
            'svg',
            {
                attrs: {
                    width: this.params.width,
                    height: this.params.height,
                    viewBox
                },
                style: {
                    display: 'block'
                }
            },
            [].concat(
                gradient ? this.$createElement('defs', {}, [
                    gradient.type === 'linear' ? this.$createElement('linearGradient', {
                        attrs: {
                            id: 'gradient' + this.effectId,
                            // gradientTransform: `rotate(${gradient.angle})`,
                            x1: gradient.x1,
                            y1: gradient.y1,
                            x2: gradient.x2,
                            y2: gradient.y2
                        }
                    }, gradient.stops.map(stop =>
                        this.$createElement('stop', {
                            attrs: { offset: stop.offset + '%', 'stop-color': stop.color }
                        })
                    )) : createRadialGradient()
                ]) : [],
                shapeDefs.map(parseShape)
            )
        );
    }
};